import React from 'react';
import {Button} from "@mui/material";
import { useKeycloak } from "@react-keycloak/web";
import LogoutIcon from '@mui/icons-material/Logout';
import {PATHS} from "../../../../router/paths";

const NavbarMenuButtonLogout = () => {
	const { keycloak, initialized } = useKeycloak();
	
	if (!initialized || (initialized && !keycloak.authenticated)) {
		return <></>;
	}

	return (
		<Button color="inherit" sx={{mr: 0}} onClick={() => keycloak.logout({redirectUri: window.location.origin + PATHS.defaultAfterLogout})}>
			<LogoutIcon/>
		</Button>
	);

};

export default NavbarMenuButtonLogout;
